var render = function render(){var _vm=this,_c=_vm._self._c;return _c('invoices-table',{attrs:{"invoices":_vm.invoices,"top-paging":false,"simplify":"","title-bar":"","actionable":""}},[_c('create-invoice',{attrs:{"project":_vm.project}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }